module.exports = __webpack_public_path__ + "1b44d329616bdb9e7c0955ef66713d47.svg";